// extracted by mini-css-extract-plugin
export default {"customRadio":"CustomGroupedRadioButton_customRadio__tJ1T8","Mui-checked":"CustomGroupedRadioButton_Mui-checked__TCBlU"};